import { CommonModule } from '@angular/common';
import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';
import { formatDuration } from '../course-creator/course-publish/utils/duration.util';

@Component({
  selector: 'app-course-structure',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './course-structure.component.html',
  styleUrl: './course-structure.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CourseStructureComponent {
  course = input<ChallengeGen.Course | null | undefined>(null);

  tasks = input<ChallengeGen.Task[]>([]);

  /** Currently selected task ID */
  selectedTaskId = input<string | null>(null);

  /** When true, tasks are not clickable (e.g. course not joined) */
  tasksDisabled = input<boolean>(false);

  taskClick = output<ChallengeGen.Task>();

  formatDuration = formatDuration;

  isTaskCompleted(task: ChallengeGen.Task): boolean {
    return !!(task as { completed?: boolean }).completed;
  }

  isTaskSelected(task: ChallengeGen.Task): boolean {
    return task.id === this.selectedTaskId();
  }

  onTaskClick(task: ChallengeGen.Task, event: Event): void {
    if (this.tasksDisabled()) return;
    this.taskClick.emit(task);
    (event.currentTarget as HTMLElement)?.blur();
  }
}
